export default __webpack_public_path__ + "static/media/Icons_14.be351df6.svg";